module.exports = __webpack_public_path__ + "static/img/none-data.abf152c8.svg";